import { motion } from "framer-motion";
import { Phone } from "lucide-react";
import { scrollToSection } from "@/App";

export const PHONE_DISPLAY = "(865) 660-9589";
export const PHONE_TEL = "tel:+18656609589";

export default function Nav() {
  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1], delay: 0.2 }}
      className="fixed top-0 left-0 right-0 z-50 border-b border-white/10 bg-[#050505]/80 backdrop-blur-xl"
      data-testid="main-nav"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 h-16 md:h-20 flex items-center justify-between">
        <button
          onClick={() => scrollToSection("hero")}
          className="flex items-center group"
          data-testid="nav-logo"
        >
          <img
            src="/tn-hvac-logo.png"
            alt="TN HVAC — Heating & Cooling"
            className="h-12 md:h-14 w-auto group-hover:opacity-85 transition-opacity duration-300"
          />
        </button>

        <nav className="hidden md:flex items-center gap-8 font-mono-tech text-xs uppercase tracking-[0.2em] text-zinc-400">
          <button
            onClick={() => scrollToSection("services")}
            className="hover:text-[#FF6B00] transition-colors duration-300"
            data-testid="nav-services-link"
          >
            Services
          </button>
          <button
            onClick={() => scrollToSection("about")}
            className="hover:text-[#FF6B00] transition-colors duration-300"
            data-testid="nav-about-link"
          >
            Why Us
          </button>
          <button
            onClick={() => scrollToSection("quote")}
            className="hover:text-[#FF6B00] transition-colors duration-300"
            data-testid="nav-quote-link"
          >
            Free Estimate
          </button>
        </nav>

        <a
          href={PHONE_TEL}
          className="flex items-center gap-2 bg-[#FF6B00] hover:bg-[#E66000] text-[#050505] font-semibold text-sm px-4 md:px-6 py-2.5 rounded-sm transition-colors duration-300"
          data-testid="nav-call-button"
        >
          <Phone className="w-4 h-4" strokeWidth={2.5} />
          <span className="hidden sm:inline">{PHONE_DISPLAY}</span>
          <span className="sm:hidden">Call Now</span>
        </a>
      </div>
    </motion.header>
  );
}
